import { toast } from "react-toastify";

export function dispatchItemToRedux({ type, payload }) {
  return { type, payload };
}

export function showResponseError(err) {
  if (err && err.response && err.response.data && err.response.data.message) {
    toast(err.response.data.message, { type: "error" });
  }
}

const setCookie = (name, value) => {
  var expiryDate = new Date();
  expiryDate.setMonth(expiryDate.getMonth() + 4);
  document.cookie = `${name}=${value};expires=${expiryDate};path=/`;
};
const deleteCookie = (name) => {
  document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
};
const getCookie = (name) => {
  if (document.cookie.length > 0) {
    var c_start = document.cookie.indexOf(name + "=");
    if (c_start !== -1) {
      c_start = c_start + name.length + 1;
      var c_end = document.cookie.indexOf(";", c_start);
      if (c_end === -1) {
        c_end = document.cookie.length;
      }
      return unescape(document.cookie.substring(c_start, c_end));
    }
  }
  return "";
};

export { setCookie, getCookie, deleteCookie };
